module.exports = __webpack_public_path__ + "files/8dfeea4460c023f85c6860ad3cfdd67e.png";